module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a18"
    }
  }), _vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Should you have previously read about “the Valentine’s Day incident,” I’d be spared a ton of exposition and exclamation marks and could just cut to the chase.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Even if you haven’t, you’ve undoubtedly read about a similar “incident”—the quote marks were the media’s, not mine—involving some bigot.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Everyone had a strong opinion about the “incident.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("This probably included you. No mea culpa will change that.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("But I’ve gotten ahead of myself, which my husband, Dom, reminds me I’m wont to do, especially when it comes to the night of February 14.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05107d20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0